export default __webpack_public_path__ + "static/media/gulmaria9.dc111e18.jpg";